import { type CSSProperties, type ReactNode } from "react";

/**
 * Canonical horizontal grid for landing content.
 * Centered 1248px content column with responsive gutters:
 *   desktop ≥1269 — 16px · tablet 769–1268 — 40px · mobile <769 — 20px
 *
 * Centering note: the global `* { margin: 0 }` reset in globals.css is
 * un-layered and therefore overrides Tailwind's layered `mx-auto`, so it
 * cannot be used here. Standalone <Container> centers via the inline
 * `marginInline: auto` below; when this class string is applied directly,
 * the parent must center it (e.g. a flex column with `items-center`).
 */
export const CONTAINER_CLASS =
  "w-full max-w-[1248px] px-[16px] max-desktop:px-[40px] max-tablet:px-[20px]";

const CENTER_STYLE: CSSProperties = { marginInline: "auto" };

interface ContainerProps {
  className?: string;
  children: ReactNode;
  style?: CSSProperties;
}

export function Container({ className = "", children, style }: ContainerProps) {
  return (
    <div className={`${CONTAINER_CLASS} ${className}`} style={{ ...CENTER_STYLE, ...style }}>
      {children}
    </div>
  );
}
